import React, { Dispatch, FC, memo, SetStateAction, useCallback, useState } from 'react';

import { IAdditionalProps, IVasInfo } from '@r1-frontend/api-domru/api-profile/v1/vas/dto/ResponseDto';

import { AccordionAnimate, AccordionAnimateBody, AccordionAnimateHeader } from '@r1-frontend/ui-react/components/accordions/AccordionAnimate';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';

import { getSubscriptionInfo } from '~/src/features/subscriptionDetail/BannerButton/getSubscriptionInfo';
import { clearHTMLTags, clearNbsp } from '~/src/helpers/string';

import SubscriptionBenefitsTextBlock from './SubscriptionBenefitsTextBlock';

import * as ST from './styled';

interface IBenefits {
    title: string,
    value: string,
}

interface IProps {
    isOpen: boolean,
    onClose: () => void,
    popupImage: string,
    onClickUnAuth: Dispatch<SetStateAction<boolean>>,
    onSendResult: () => void,
    subscription?: IVasInfo<IAdditionalProps>,
    isAuth: boolean,
    setIsPhonePopupOpen: Dispatch<SetStateAction<boolean>>,
    isRewriteSubscription: boolean,
}

const DetailedSubscriptionPopup: FC<IProps> = ({
    isOpen,
    onClose,
    subscription,
    popupImage,
    onClickUnAuth,
    onSendResult,
    isAuth,
    setIsPhonePopupOpen,
    isRewriteSubscription,
}): JSX.Element => {
    const [isOpenDescription, setIsOpenDescription] = useState(false);
    const onToggleHandler = (status: boolean) => setIsOpenDescription(status);

    const onClick = useCallback(() => {
        setIsPhonePopupOpen(true);
        onClose();
    }, []);

    const onClickUnAuthPopup = useCallback(() => {
        onClickUnAuth(true);
        onClose();
    }, []);

    // FIXME: `benefitsAuth` is of type IBenefits[]
    // `notAuthBenefits` is of type string[]
    // it causes TS errors when mapping and misunderstanding of `benefits` variable, that can't be of both types
    const benefitsAuth = subscription?.contentData?.props?.find(item => item.name === 'benefits');
    // @ts-ignore
    // TODO: Fix later in https://ticket.ertelecom.ru/browse/WEB-43177
    const benefitsNotAuth = clearNbsp(clearHTMLTags(subscription?.body_full))
        .split('.')
        .filter((subStr: string) => subStr !== '');

    return (
        <DefaultPopup
            isOpen={isOpen}
            fullWidth={false}
            onClose={onClose}
        >
            <div>
                <ST.ImageBlock src={popupImage} alt={`Изображение ${subscription?.nameVas}`} />
            </div>
            <ST.PopupInner>
                <ST.PopupTitle>{subscription?.nameVas}</ST.PopupTitle>
                <ST.BenefitsTextBlock>
                    { isAuth
                        ? benefitsAuth?.value?.map((item: IBenefits, index: number) => <SubscriptionBenefitsTextBlock benefits={item?.value} key={index}/>)
                        : benefitsNotAuth?.map((item: string, index: number) => <SubscriptionBenefitsTextBlock benefits={item} key={index}/>)
                    }
                </ST.BenefitsTextBlock>
                <AccordionAnimate isAnimate={false} onToggle={onToggleHandler}>
                    <AccordionAnimateHeader>
                        <ST.Ask isOpen={isOpenDescription}>Как смотреть подписку</ST.Ask>
                    </AccordionAnimateHeader>
                    <AccordionAnimateBody>
                        {getSubscriptionInfo(subscription?.nameVas)}
                    </AccordionAnimateBody>
                </AccordionAnimate>
                <ST.StyledButton
                    bType={'action'}
                    size={'medium'}
                    onClick={isAuth ? isRewriteSubscription ? () => onClick() : () => onSendResult() : () => onClickUnAuthPopup()}
                >
                    Подключить за {subscription?.pricesV2?.length && subscription.pricesV2[0].value} ₽/мес
                </ST.StyledButton>
            </ST.PopupInner>
        </DefaultPopup>
    );
};

export default memo(DetailedSubscriptionPopup);
